// Levenshtein distance for the "did you mean" fixes.
function editDistance(a: string, b: string): number {
  let prev = Array.from({ length: b.length + 1 }, (_, i) => i);
  for (let i = 1; i <= a.length; i++) {
    const row = [i];
    for (let j = 1; j <= b.length; j++) {
      row.push(
        Math.min(
          prev[j] + 1,
          row[j - 1] + 1,
          prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1),
        ),
      );
    }
    prev = row;
  }
  return prev[b.length];
}

/** Candidates similar enough to `target` to offer as replacements, closest
 *  first, capped at `limit`. */
export function closestMatches(
  target: string,
  candidates: Iterable<string>,
  limit = 3,
): string[] {
  const maxDistance = Math.max(2, Math.floor(target.length / 3));
  return [...candidates]
    .map((c): [string, number] => [
      c,
      editDistance(target.toLowerCase(), c.toLowerCase()),
    ])
    .filter(([, d]) => d <= maxDistance)
    .sort((a, b) => a[1] - b[1])
    .slice(0, limit)
    .map(([c]) => c);
}
